<template>
  <div>
    <b-modal v-model="alert.show" title="И-баримтаа автоматаар бүртгэх үйлчилгээнд бүртгүүлээрэй">
      <!-- <Form label-position="top" label-width="100%">
        <FormItem label="Бүлгийн нэр">
          <Input v-model="convCur.team" ></Input>
        </FormItem>
      </Form> -->
      <div v-html="alert.msg">
        
      </div>
      <template #modal-footer>
        <div class="mg-l-auto btn-group">
          <button v-show="alert.showOk == false"
            @click="alert.show = false"
            type="button"
            class="btn btn-danger btn-xs btn-uppercase"
          >
            Хаах
          </button>
          <button v-show="alert.showOk"
            @click="ok()"
            type="button"
            class="btn btn-primary btn-xs btn-uppercase"
          >
            Бүртгүүлэх
          </button>

        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/api/all";
import { MessageBox } from "element-ui";
//import { localSave } from "@/libs/util";
import Cookies from "js-cookie";
//const moment = require("moment");
import { mapActions } from "vuex";
export default {
  data() {
    return {
      alert: {
        //minDays: 180,
        leftDays: 0,
        expireDays: 1,
        show: false,
        msg: "",
        showOk: true
      },
    };
  },
  mounted() {
    if (
      this.$store.state.app.activeGroup.id == 9157 &&
      (this.$store.state.user.userInfo.ebarimt == "" ||
        this.$store.state.user.userInfo.ebarimt == null ||
        this.$store.state.user.userInfo.ebarimt == undefined)
    ) {
      this.alert.msg =
        "" +
        //this.$store.state.user.userInfo.register +
        "Та И-баримтаа холбосон тохиолдолд таны төлбөр төлсөн нэхэмжлэхүүд автоматаар бүртгэгдэх болно.";

      if (!Cookies.get("ebarimt-easyregister-show")) {
        this.alert.show = true;
        //this.showLicenseAlert();
      }
    }
  },
  methods: {
    ...mapActions([
      "handleUserInfo", "handleLoading"
    ]),
    cancel() {
      Cookies.set("ebarimt-easyregister-show", 1, {
        expires: this.alert.expireDays,
      });
    },
    ok() {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "ebarimt/SaveEasyRegister" },
        
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          //this.alert.show=false;

          this.alert.msg = "Таны и-баримтын бүртгэл <b>" + res.data.ebarimtCode + "</b> амжилттай холбогдлоо. <br> Баярлалаа.";
          this.alert.showOk=false;
          this.handleUserInfo({ store: this.$store });
          this.$bvToast.toast(`Амжилттай хадгаллаа.`, {
            title: "Мэдэгдэл",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "success",
            toaster: "b-toaster-bottom-left",
          });
        }
        else
          this.alert.show=false;
      });
    },
    showLicenseAlert() {
      MessageBox.confirm(this.alert.msg, "И-баримтаа автоматаар бүртгэх үйлчилгээнд бүртгүүлээрэй", {
        //confirmButtonText: ,
        confirmButtonText: "Тэгье",
        cancelButtonText: "Үгүй",
        callback: (action) => {
          if (action == "cancel") {
            Cookies.set("ebarimt-easyregister-show", 1, {
              expires: this.alert.expireDays,
            });
            //localSave("ebarimt-easyregister-show", 1);
          } else if (action == "confirm") {
            //ebarimt call
          }
        },
      });
    },
  },
};
</script>
